<template>
  <modal :title="title" ref="modal">
    <post-search-loader :post-search-id="postSearchId" v-model="postSearch" />
    <div v-if="postSearch" class="q-gutter-y-md">
      <q-input
        v-for="(kw, i) in postSearch.keywords"
        :key="i"
        :model-value="kw"
        dense
        readonly
      >
        <template v-slot:append>
          <q-btn
            icon="fa fa-trash"
            title="Remove keyword"
            flat
            round
            dense
            @click="removeKeyword(kw)"
          />
        </template>
      </q-input>
      <q-input
        v-model="keyword"
        placeholder="Add keyword..."
        dense
        autofocus
        @keyup.enter="addKeyword"
      >
        <template v-slot:append>
          <q-btn icon="fa fa-plus" flat round @click="addKeyword" />
        </template>
      </q-input>
    </div>
    <template v-slot:actions>
      <async-btn
        label="Save"
        color="primary"
        :task="task"
        :disabled="!canSave"
        @click="save"
      />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import {
  Modal as ModalElement,
  PostSearch,
} from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import { edit } from '.';
import PostSearchLoader from './PostSearchLoader.vue';

interface Data {
  postSearch: PostSearch|null,
  keyword: string,
  task?: Promise<PostSearch>
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    PostSearchLoader,
    Modal,
    AsyncBtn,
  },
  props: {
    postSearchId: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      default: 'Edit Search',
    },
  },
  data(): Data {
    return {
      postSearch: null,
      keyword: '',
      task: undefined,
    };
  },
  computed: {
    canSave(): boolean {
      return (
        this.postSearch !== null
        && this.postSearch.keywords.length > 0
      );
    },
  },
  methods: {
    addKeyword() {
      if (!this.postSearch || this.keyword === '') return;
      if (this.postSearch.keywords.includes(this.keyword)) return;
      this.postSearch.keywords.push(this.keyword);
      this.keyword = '';
    },
    removeKeyword(keyword: string) {
      if (!this.postSearch) return;
      const index = this.postSearch.keywords.findIndex(kw => kw === keyword);
      if (index >= 0) {
        this.postSearch.keywords.splice(index, 1);
      }
    },
    save() {
      if (!this.postSearch) return;
      this.task = edit(this.postSearchId, this.postSearch.keywords);
      this.task.then((postSearch: PostSearch) => {
        this.$emit('ok', postSearch);
        (this.$refs.modal as ModalElement).hide();
        notify('Saved successfully.');
      });
    },
  },
});
</script>
